import { useField } from "vee-validate";

export function objComparatorICase(a, b, property) {
  return comparatorICase(a[property], b[property]);
}

export function objComparatorNumber(a, b, property) {
  let keyA = a[property];
  let keyB = b[property];
  if (keyA < keyB) return -1;
  if (keyA > keyB) return 1;
  return 0;
}

export function comparatorICase(a, b) {
  let keyA = a.toUpperCase();
  let keyB = b.toUpperCase();
  if (keyA < keyB) return -1;
  if (keyA > keyB) return 1;
  return 0;
}

/**
 * IMPORTANT, use this function only after the useForm() call!
 * @param schema yup schema object
 */
export function getFormFromSchema(schema) {
  return Object.fromEntries(
    Object.keys(schema.fields).map(key => {
      if (schema.fields[key].type === 'boolean') {
        return [key, useField(key, undefined, {
          initialValue: false,
        })];
      } else {
        return [key, useField(key, schema)];
      }
    })
  );
}

/**
 * IMPORTANT, use this function only after the useForm() call!
 * This function REQUIRE MANUAL MANAGEMENT OF ARRAY FIELDS
 * @param schema yup schema object
 * @param schemaRoot
 * @param prefix list of prefixes like ['pilotage', 'board_data'] -> 'pilotage.board_data'
 */
export function getFormFromSchemaRecursive(schema, schemaRoot = schema, prefix = []) {
  return Object.fromEntries(
    Object.keys(schema.fields).map(key => {
      const prefixedKey = [...prefix, key].join('.');
      if (schema.fields[key].type === 'object') {
        return [key, getFormFromSchemaRecursive(schema.fields[key], schemaRoot, [...prefix, key])];
      } else if (schema.fields[key].type === 'boolean') {
        return [key, useField(prefixedKey, schemaRoot, {
          initialValue: false,
        })];
      } else if (schema.fields[key].type === 'array') {
        return [null, null];
      } else {
        return [key, useField(prefixedKey, schemaRoot)];
      }
    }).filter((v) => v[0] !== null)
  );
}

export function setObjectIntoFormBySchema(obj, form, schema, skip_fields = []) {
  for (const key of Object.keys(schema.fields)) {
    if (schema.fields[key].type === 'object') {
      const nestedSkipFields = skip_fields.filter(val => val.startsWith(key + '.')).map(val => {
        return val.splice(key.length + 1);
      });
      setObjectIntoFormBySchema(obj[key], form[key], schema.fields[key], nestedSkipFields);
    } else {
      if (skip_fields.includes(key)) continue;
      form[key].value.value = obj[key];
    }
  }
}

export function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    if (file) {
      const filereader = new FileReader();
      filereader.readAsDataURL(file);
      filereader.onload = () => resolve(filereader.result.replace("data:", "").replace(/^.+,/, ""));
      filereader.onerror = (error) => reject(error);
    } else {
      reject('No file provided');
    }
  });
}

export function toLocalDatetime(input) {
  if (input === null) return null;
  const date = new Date(input);
  return date.toLocaleDateString('sv-SE') + 'T' + date.toLocaleTimeString('sv-SE', { hour12: false }).slice(0, 5);
}

export function toUtcDatetime(input) {
  if (input === null) return null;
  const localDate = new Date(input);
  return localDate.toISOString();
}

export function toPrettyDatetime(input) {
  if (input === null) return null;
  const date = new Date(input);
  return date.toLocaleDateString('sv-SE') + ' ' + date.toLocaleTimeString('sv-SE', { hour12: false });
}

export function removeNullEmptyFromObj(msgDict) {
  // Remove from the dict every appearance of null and empty string
  Object.keys(msgDict).forEach(key => {
    if (msgDict[key] === null || msgDict[key] === '') {
      delete msgDict[key];
    }
  });
}
